import type { StaffBookingRequest, StaffBookingResponse } from '../api/generated';
import { STAFF_BOOKING_TYPE } from '../components/StaffBookings/staffBookingConstants';
import { useBookings } from './useBookings';
import type { UseBookingsResult } from './useBookings';

export type UseStaffBookingsResult = UseBookingsResult<StaffBookingRequest, StaffBookingResponse>;

export function useStaffBookings(locationId: string | null): UseStaffBookingsResult {
  return useBookings<StaffBookingRequest, StaffBookingResponse>(STAFF_BOOKING_TYPE, locationId);
}
